// extracted by mini-css-extract-plugin
export default {"container":"ProductOffering_container__k31y3","smalldiv":"ProductOffering_smalldiv__2kp9x"};